import React, { useState } from 'react';
import { FaInfoCircle, FaShieldAlt, FaLock } from 'react-icons/fa';
import '../assets/styles/GDPRConsent.css';
const GDPRConsent = ({ onConsentChange }) => {
  const [consent, setConsent] = useState(false);

  const handleConsentChange = (e) => {
    const isChecked = e.target.checked;
    setConsent(isChecked);
    onConsentChange(isChecked);
  };

  return (
    <div className="gdpr-consent-container">
      <div className="gdpr-header">
        <div className="gdpr-icon">
          <FaShieldAlt />
        </div>
        <h3>Data Protection Notice</h3>
      </div>

      <div className="gdpr-content">
        <p>
          <FaInfoCircle style={{ marginRight: '8px' }} />
          The information you provide to the investor.startupdriver.co platform is processed in accordance with applicable data protection regulations, including GDPR, to evaluate your application, provide personalized services, and conduct statistical analyses.
        </p>

        <div className="privacy-details">
          <h4>Privacy Notice Summary</h4>
          <ul>
            <li>Your data will be used to evaluate your application and provide you with a tailored service.</li>
            <li>Your financial and operational data may be used for analytical purposes only to calculate industry averages.</li>
            <li>Your data will not be shared with third parties without your explicit consent.</li>
            <li>Your identity and contact information will be processed to communicate with you and ensure account security.</li>
            <li>Your data will be kept secure in compliance with EU and local data protection regulations.</li>
          </ul>

          <div className="data-security">
            <FaLock style={{ marginRight: '8px' }} />
            <span>All your data is encrypted and protected.</span>
          </div>
        </div>

        <div className="consent-actions">
          <div className="consent-checkbox">
            <input
              type="checkbox"
              id="gdprConsent"
              checked={consent}
              onChange={handleConsentChange}
              required
            />
            <label htmlFor="gdprConsent">
              I have read and understood the <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and consent to the processing of my personal data.
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GDPRConsent;